<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on }">
      <div class="button-quit-wrapper">
        <router-link :to="{ path: '/' }" class="button-quit">
          <v-icon large @click="removeUser" class="button-quit-icon">
            exit_to_app
          </v-icon>
        </router-link>
      </div>
    </template>
    <span>Déconnexion</span>
  </v-tooltip>
</template>

<script>
export default {
  methods: {
    removeUser() {
      this.$store.dispatch('stopIntervalTimer');
      this.$store.dispatch('removeUser');
    },
  },
};
</script>

<style lang="scss" scoped>
.button-quit-wrapper {
  display: flex;
  height: 36px;
  flex-direction: column;
  justify-content: center;
  margin: 6px 8px;
  text-decoration: none;
  width: 100%;

  .button-quit {
    display: block;
    height: 100%;
    text-decoration: none;

    .button-quit-icon {
      color: white;
      display: block;
      height: 100%;
    }

    &:any-link {
      text-decoration: none;
    }
  }
}
</style>
